module.exports = __webpack_public_path__ + "img/myt.35dd3f99.svg";